export const apiBaseUrl = process.env.REACT_APP_API_ENDPOINT;



// WEBPACK FOOTER //
// ./src/env.ts